module.exports = app_supply_protool_configuration;